import { SPHERES } from './spheres.js';
import { balance, lowSpheres } from './balance.js';
import { DEFAULT_LOCALE } from './locale.js';
import { plural } from './plural.js';
import { domainCopy } from './i18n/index.js';
import { ru } from './i18n/ru.js';
/**
 * наблюдатель MVP: детерминированная функция от значений и явно выбранного seed.
 * без сети, без LLM, без оплаты. тексты авторские, лежат в i18n.
 */
/** провокации по сферам на русском: старые записи наблюдателя находят по ним главу */
export const PROV = ru.prov;
export { plural };
/** детерминированный 32-битный хэш seed-строки */
export function seedHash(seed) {
    let h = 2166136261;
    for (let i = 0; i < seed.length; i++) {
        h ^= seed.charCodeAt(i);
        h = Math.imul(h, 16777619);
    }
    return h >>> 0;
}
/**
 * один и тот же seed и те же значения всегда дают один и тот же вывод.
 * seed выбирает клиент (обычно dayKey + счётчик нажатий).
 */
export function observe(values, seed, locale = DEFAULT_LOCALE) {
    const t = domainCopy(locale);
    const low = lowSpheres(values);
    if (low.length === 0)
        return t.observe.balanced({ coh: balance(values) });
    const weakId = low[0];
    const variants = t.prov[weakId];
    const variant = variants[seedHash(seed) % variants.length];
    let lead = variant[0];
    let body = variant[1];
    const act = variant[2];
    if (low.length >= 2) {
        const grpOf = (id) => SPHERES.find((s) => s.id === id)?.grp;
        const inLow = low.filter((id) => grpOf(id) === 'in').length;
        const outLow = low.length - inLow;
        // равенство контуров не даёт основания для вывода — примечание добавляем только при перевесе
        if (inLow > outLow)
            body += ' ' + t.observe.contourIn;
        else if (outLow > inLow)
            body += ' ' + t.observe.contourOut;
        lead = t.observe.lowLead({ n: low.length }) + lead;
    }
    return { lead, body, act };
}
//# sourceMappingURL=observer.js.map